import {
  Box, FormControl, FormLabel, Select,
} from '@chakra-ui/react';
import useUpdateField from '../useUpdateField';

const formats = [
  { key: 'dd/MM/yyyy', value: 'dd/mm/yyyy' },
  { key: 'MM/dd/yyyy', value: 'mm/dd/yyyy' },
  { key: 'yyyy/MM/dd/', value: 'yyyy/mm/dd/' },
];
const DatePickerOptions = ({ field }) => {
  const [format, setFormat] = useUpdateField(field, 'props.format', 'MM/dd/yyyy');

  return (
    <Box>
      <FormControl mt="4">
        <FormLabel fontSize="sm" mb="1">Direction</FormLabel>
        <Select value={format} onChange={(e) => setFormat(e.target.value)}>
          {formats.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
        </Select>
      </FormControl>
    </Box>
  );
};

export default DatePickerOptions;
